import { CREATE_JOB, GET_JOB, JOB_REQUEST, DELETE_JOB, UPDATE_JOB, JOB_REQUEST_FAILURE } from "../types";

const initialState = {
  jobs: [],
  loading: false,
  error: null,
};

const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOB_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_JOB: {
      return {
        ...state,
        jobs: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_JOB:
      return {
        ...state,
        jobs: [action.payload, ...state.jobs],
        loading: false,
        error: null
      };
    case UPDATE_JOB:
      const jobsData = state.jobs.slice(0);
      const uIndex = jobsData.findIndex((data) => data.id === action.payload.id);
      jobsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        jobs: [ ...jobsData ],
        loading: false,
        error: null
      };
    case DELETE_JOB:
      const jobs = state.jobs?.slice(0);
      const index = jobs.findIndex((data) => data.id === action.id);
      if (index > -1) {
          jobs.splice(index, 1);
      }
      return {
        ...state,
        jobs: [...jobs],
        loading: false,
        error: null
      }
    case JOB_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default jobReducer